import { render, staticRenderFns } from "./GnvMassaBenefitsModal.vue?vue&type=template&id=a2baa032"
import script from "./GnvMassaBenefitsModal.vue?vue&type=script&lang=js"
export * from "./GnvMassaBenefitsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports